import { render, staticRenderFns } from "./ListItemAddButton.vue?vue&type=template&id=53cb8154&scoped=true&"
import script from "./ListItemAddButton.vue?vue&type=script&lang=js&"
export * from "./ListItemAddButton.vue?vue&type=script&lang=js&"
import style0 from "./ListItemAddButton.vue?vue&type=style&index=0&id=53cb8154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb8154",
  null
  
)

export default component.exports